import { render } from "./DairyCattleDataForm.vue?vue&type=template&id=d96050f6&scoped=true&ts=true"
import script from "./DairyCattleDataForm.vue?vue&type=script&lang=ts"
export * from "./DairyCattleDataForm.vue?vue&type=script&lang=ts"

import "./DairyCattleDataForm.vue?vue&type=style&index=0&id=d96050f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d96050f6"]])

export default __exports__